import { IconButton, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeIcon from '@mui/icons-material/LightModeOutlined';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import { useUiStore } from '@/store/uiStore';

/** Theme mode + density toggles, persisted via the UI store (spec §4). */
export function ThemeControls() {
  const mode = useUiStore((s) => s.mode);
  const density = useUiStore((s) => s.density);
  const toggleMode = useUiStore((s) => s.toggleMode);
  const setDensity = useUiStore((s) => s.setDensity);

  return (
    <>
      <Tooltip title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
        <IconButton onClick={toggleMode} aria-label="Toggle color mode">
          {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
      </Tooltip>
      <Tooltip title={density === 'compact' ? 'Comfortable density' : 'Compact density'}>
        <IconButton
          onClick={() => setDensity(density === 'compact' ? 'comfortable' : 'compact')}
          aria-label="Toggle density"
        >
          {density === 'compact' ? <DensityMediumIcon /> : <DensitySmallIcon />}
        </IconButton>
      </Tooltip>
    </>
  );
}
